import * as React from "react";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as ProxyHelper from "../proxyManagement/ProxyHelper";
import { Link } from 'react-router-dom';

class ProxySuggestionsSummary extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { selectedProxySuggestionUsers } = this.props;
        logUI(`MBHWeb.UI.ProxySuggestionsSummary.ComponentDidMount`, new Date(), Tools.getURLPath(), { selectedUserCount: selectedProxySuggestionUsers.length, selectedUsers: selectedProxySuggestionUsers });
    }

    UpdatePreference() {
        const { selectedProxySuggestionUsers } = this.props;
        logUI(`MBHWeb.UI.ProxySuggestionsSummary.Clicked.Continue`, new Date(), Tools.getURLPath(), { selectedUserCount: selectedProxySuggestionUsers.length, selectedUsers: selectedProxySuggestionUsers });
    }
    render() {
        const { selectedProxySuggestionUsers } = this.props;
        const subHeading = `We were able to request access to ${selectedProxySuggestionUsers.length} family members.`
        const proxySummaryInfo = "You will be able to add or remove family members or grant someone permission to manage your health care from your profile."
        return (
            
            <div className = "container-fluid proxy-suggestion-summary-container">
                <div className="row" >
                    <div className="col-12 maxWidth-content">
                        <h1 className="onboarding-layout__page-heading ">Family members</h1>
                    </div>
                    <div className="col-12 maxWidth-content">
                        <div className="row proxy-suggestions-summary__body">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12" >
                                        <p className="proxy-suggestions-summary__subheading ">{subHeading}</p>
                                    </div>
                                </div>
                                {selectedProxySuggestionUsers.map((user, index) => {
                                    return (
                                        <div className='user-proxy-suggestions-summary__list-item' key={index}>
                                            <div className="row" >
                                                <div className="col-6 proxy-suggestions-summary__list_margin">
                                                    <div className="user-proxy-suggestions-summary__details" >
                                                        {user.display.name}
                                                    </div>
                                                    {user.hasError == true ?
                                                        <div className="user-proxy-suggestions__pill proxy_error" >
                                                            Medical Records
                                                            <span className="icon-input-error proxy-suggestions-summary__icon"/>
                                                        </div>
                                                        :
                                                        <div className="user-proxy-suggestions__pill proxy_success" >
                                                            Medical Records
                                                            <span className="icon-check proxy-suggestions-summary__icon" />
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        
                        <div className="col-12 maxWidth-content">
                            <div className="row">
                                <div className="col-12 proxy-suggestions-summary-content" >
                                    <p className="proxy-suggestions-summary-info">{proxySummaryInfo}</p>
                                </div>
                            </div>
                        </div>       
                        <div className="row text-center proxy-suggestions-summary__footer">
                            <div className="col-12 add-family-btn">
                                <Link to={{ pathname: '/onboarding/managenotifications' }}
                                    className="btn btn-primary"
                                    onClick={() => { this.UpdatePreference() }}
                                >
                                    Continue
                                </Link>
                            </div>
                            
                        </div>
                    </div>
                </div>                           
             </div>  
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedProxySuggestionUsers: state.session.selectedProxySuggestionUsers,
    };
};

export default connect(mapStateToProps, null)(ProxySuggestionsSummary);